import service from "api/service";

export const sendMail = (data) => (dispatch) => {
    return service.contactService.sendMail(data).then((res) => {
        return res
    })
}